var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path28, _g9, _g10, _g11, _g12, _g13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 46 50",
    style: {
      enableBackground: "new 0 0 46 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#010B40;}\n\t.st1{opacity:0.62;fill:#FFFFFF;enable-background:new    ;}\n\t.st2{opacity:0.79;}\n\t.st3{opacity:0.76;}\n\t.st4{opacity:0.1;enable-background:new    ;}\n\t.st5{opacity:5.000000e-02;enable-background:new    ;}\n\t.st6{fill:#C6C6C6;}\n\t.st7{fill:#828383;}\n\t.st8{opacity:0.1;fill:#162B4C;enable-background:new    ;}\n\t.st9{opacity:5.000000e-02;fill:#EEECEB;enable-background:new    ;}\n\t.st10{opacity:0.1;fill:#E5E3E1;enable-background:new    ;}\n\t.st11{opacity:5.000000e-02;fill:#E5E3E1;enable-background:new    ;}\n\t.st12{fill:#606060;}\n\t.st13{fill:url(#SVGID_1_);}\n\t.st14{fill:url(#SVGID_00000040554793601638236950000011742636873333226671_);}\n\t.st15{fill:url(#SVGID_00000027587065582836785110000011897859056487876019_);}\n\t.st16{fill:url(#SVGID_00000156546421535266813970000011527694617464163263_);}\n\t.st17{fill:url(#SVGID_00000079451402790011876290000015437537187972057224_);}\n\t.st18{fill:url(#SVGID_00000018950961842368953210000017191496543227139237_);}\n\t.st19{fill:url(#SVGID_00000060014248876204492870000011115845883004507297_);}\n\t.st20{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.2,3.2C2.3,3.1,2.5,3,2.7,3.2C10.2,9.4,7.8,27,7.8,27C-2.9,15,1.3,5,2.2,3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.9,6.3c0,0,0,0,0.1,0l0,0l0,0c0.1,0.8,0.2,1.7,0.3,2.6c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6 l0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0.1,0.4,0.2,0.8,0.2,1.3l0.3,1.2c0.1,0.5,0.2,0.9,0.3,1.3s0.2,0.8,0.3,1.2 c0.2,0.8,0.4,1.7,0.7,2.5l0.4,1.2L6,20.5c0,0.1,0.1,0.2,0.1,0.3l0.2,0.6l0.4,1.2l0.4,1.2c0.1,0.2,0.1,0.4,0.2,0.6L7.5,25 c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0.2,0.1,0.4,0.2,0.6l0,0l0,0l0,0c-0.1-0.2-0.2-0.4-0.3-0.6c-0.1-0.2-0.2-0.4-0.3-0.6l-0.3-0.6 c0-0.1-0.1-0.2-0.1-0.3l-0.1-0.3l-0.5-1.2c-0.1-0.4-0.3-0.8-0.4-1.2l-0.2-0.7c-0.1-0.2-0.1-0.4-0.2-0.6l-0.4-1.2L5,17.7 c-0.1-0.2-0.1-0.4-0.2-0.6l-0.2-0.6c-0.2-0.8-0.4-1.7-0.6-2.5l-0.3-1.2c-0.1-0.4-0.2-0.8-0.2-1.3c0-0.2-0.1-0.4-0.1-0.6l-0.1-0.6 c0-0.2-0.1-0.4-0.1-0.6c0-0.2-0.1-0.4-0.1-0.6C3.1,8,2.9,7.2,2.9,6.3L2.9,6.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.4,22.2c0,0,5.5-13.8,16.2-19.6c0.2-0.1,0.3,0,0.3,0.2C30.1,5.3,30.6,21,13.4,22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.9,6.5c-0.2,0.4-0.4,0.8-0.6,1.2c-0.2,0.4-0.4,0.8-0.6,1.1c-0.4,0.8-0.9,1.5-1.4,2.2 c-0.1,0.2-0.2,0.3-0.4,0.5c-0.1,0.2-0.3,0.3-0.4,0.5c-0.1,0.2-0.3,0.3-0.4,0.5L24,12.9l-0.2,0.3c-0.5,0.7-1.1,1.4-1.7,2 c-0.6,0.6-1.2,1.3-1.8,1.9c-0.1,0.1-0.1,0.2-0.2,0.2l-0.2,0.2l-0.2,0.2c-0.1,0.1-0.1,0.2-0.2,0.2l-0.5,0.4l-0.1,0.1l-0.1,0.1 l-0.2,0.2c-1.4,1.1-2.8,2.1-4.3,2.9l0,0l0,0l0,0l0.6-0.3l0.3-0.2l0.3-0.2l0.5-0.3l0.5-0.4c0.1-0.1,0.2-0.1,0.3-0.2l0.3-0.2 c0.2-0.1,0.4-0.3,0.5-0.4c0.3-0.3,0.7-0.5,1-0.8l0.2-0.2l0.1-0.1l0.1-0.1l0.5-0.4c0.1-0.1,0.1-0.2,0.2-0.2l0.2-0.2l0.2-0.2 c0.1-0.1,0.1-0.2,0.2-0.2c0.6-0.6,1.2-1.2,1.8-1.9c0.6-0.6,1.1-1.3,1.7-2l0.2-0.3l0.2-0.3c0.1-0.2,0.3-0.3,0.4-0.5 c0.3-0.3,0.5-0.7,0.7-1.1c0.5-0.7,0.9-1.5,1.4-2.2C26.8,8.4,27,8,27.2,7.6c0.1-0.2,0.2-0.4,0.3-0.6C27.6,6.9,27.7,6.7,27.9,6.5 L27.9,6.5C27.8,6.5,27.9,6.5,27.9,6.5C27.9,6.5,27.9,6.5,27.9,6.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.5,45.6c0,0-1.2-12.9-8.7-20.4c-0.1-0.1-0.3-0.1-0.3,0.1C2.7,27.3-1.6,40.4,12.5,45.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.2,28.9c0.1,0.7,0.3,1.5,0.5,2.2c0.2,0.7,0.4,1.5,0.6,2.2c0.1,0.4,0.2,0.7,0.4,1.1c0.1,0.2,0.1,0.3,0.2,0.5 L6,35.2l0.1,0.3c0.3,0.7,0.6,1.4,0.9,2.1c0.3,0.7,0.6,1.4,1,2c0,0.1,0.1,0.2,0.1,0.2l0.2,0.2l0.2,0.2c0.1,0.1,0.1,0.2,0.2,0.2 L8.9,41L9,41.1l0.1,0.1l0.2,0.2c0.2,0.3,0.4,0.6,0.6,0.9c0.1,0.2,0.2,0.3,0.3,0.5l0.2,0.2c0.1,0.1,0.1,0.2,0.2,0.2l0.3,0.4 l0.4,0.4l0.2,0.2l0.2,0.2l0.4,0.4l0,0v0h0c-1.1-1-2.1-2.2-2.9-3.5L9,41.3l-0.1-0.1L8.8,41l-0.3-0.5c-0.1-0.1-0.1-0.2-0.2-0.2 l-0.2-0.2L8,39.8c-0.1-0.1-0.1-0.2-0.2-0.2c-0.4-0.6-0.7-1.3-1-2s-0.6-1.4-0.9-2.1l-0.1-0.3l-0.1-0.3c-0.1-0.2-0.1-0.3-0.2-0.5 S5.4,34,5.4,33.9c-0.1-0.2-0.1-0.4-0.2-0.6C4.7,31.9,4.4,30.4,4.2,28.9C4.2,28.9,4.2,28.9,4.2,28.9C4.2,28.9,4.2,28.9,4.2,28.9 L4.2,28.9z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.4,47.4l-10.3,2.1l-0.2,0l-9.1-0.9V37l11.1-1.9l8,0.9l0,0.1l0,0L21.4,47.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M21.4,47.4l-10.3,2.1l-0.2,0V37.7L21,36.1L21.4,47.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M21,36.2L21,36.2l-10.1,1.5L1.8,37l11.1-1.9L21,36.2L21,36.2L21,36.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M32.8,47.9L22.5,50l-0.2,0l-9.1-0.9V37.5l11.1-1.9l8,0.9l0,0.1l0,0L32.8,47.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M32.8,47.9L22.5,50l-0.2,0V38.1l10.1-1.5L32.8,47.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M32.3,36.6L32.3,36.6l-10.1,1.5l-9.1-0.6l11.1-1.9L32.3,36.6L32.3,36.6L32.3,36.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M25.7,36.6l-10.3,2.1l-0.2,0l-9.1-0.9V26.2l11.1-1.9l8,0.9l0,0.1l0,0L25.7,36.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M25.7,36.6l-10.3,2.1l-0.2,0V26.8l10.1-1.5L25.7,36.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M25.2,25.3L25.2,25.3l-10.1,1.5l-9.1-0.6l11.1-1.9L25.2,25.3L25.2,25.3L25.2,25.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M31.5,37.1l-5.4,1.1l-0.1,0l-4.7-0.5v-6l5.8-1l4.2,0.5l0,0v0L31.5,37.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M31.5,37.1l-5.4,1.1l-0.1,0V32l5.3-0.8L31.5,37.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M31.3,31.2L31.3,31.2L26,32l-4.7-0.3l5.8-1L31.3,31.2L31.3,31.2L31.3,31.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M17.1,25.4l-5.4,1.1l-0.1,0L6.8,26v-6l5.8-1l4.2,0.5l0,0v0L17.1,25.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M17.1,25.4l-5.4,1.1l-0.1,0v-6.2l5.3-0.8L17.1,25.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M16.8,19.5L16.8,19.5l-5.3,0.8l-4.7-0.3l5.8-1L16.8,19.5L16.8,19.5L16.8,19.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M26.5,25.1l-5.4,1.1l-0.1,0l-4.7-0.5v-6l5.8-1l4.2,0.5l0,0v0L26.5,25.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M26.5,25.1l-5.4,1.1l-0.1,0V20l5.3-0.8L26.5,25.1z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M26.3,19.3L26.3,19.3L21,20l-4.7-0.3l5.8-1L26.3,19.3L26.3,19.3L26.3,19.3z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M29.3,19.1l-5.4,1.1l-0.1,0l-4.7-0.5v-6l5.8-1l4.2,0.5l0,0v0L29.3,19.1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M29.3,19.1l-5.4,1.1l-0.1,0V14l5.3-0.8L29.3,19.1z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M29.1,13.2L29.1,13.2L23.8,14l-4.7-0.3l5.8-1L29.1,13.2L29.1,13.2L29.1,13.2z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.4,19.3L14,20.4l-0.1,0l-4.7-0.5v-6l5.8-1l4.2,0.5l0,0v0L19.4,19.3z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M19.4,19.3L14,20.4l-0.1,0v-6.2l5.3-0.8L19.4,19.3z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M19.2,13.4L19.2,13.4l-5.3,0.8l-4.7-0.3l5.8-1L19.2,13.4L19.2,13.4L19.2,13.4z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M22.2,13.3l-5.4,1.1l-0.1,0L12,13.9v-6l5.8-1L22,7.4l0,0v0L22.2,13.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M22.2,13.3l-5.4,1.1l-0.1,0V8.3L22,7.5L22.2,13.3z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M22,7.5L22,7.5l-5.3,0.8L12,7.9l5.8-1L22,7.5L22,7.5L22,7.5z"
  })), /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.1,4.8c0,0.7-0.1,1.8-0.4,2.4c-0.3,0.6-1.4,1.1-1.4,1.1l-0.6-2.7L37.1,4.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M36.7,45.7c-0.6,1.8-0.5,2.9,0.1,3.5c0.6,0.7,2.1-1.3,1.7-2.3c-0.4-0.9-0.9-2.4-0.9-2.4L36.7,45.7z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M30,46.9c-1.7,0.6-3.4,1.1-3.2,1.6c0.2,0.5,3.5,0.4,4-0.1c0.5-0.4,0.4-2.2,0.4-2.2L30,46.9z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M32.7,9.4c-3.5,0.8-6.1,6.3-6.8,7.5c-0.8,1.4-1.1,3.5-0.1,3.6c0.9,0.1,5.8-5.2,6.3-6 C32.6,13.6,32.7,9.4,32.7,9.4z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,22.8c-1.8,1.3,2.8,14,3.2,14.8c0.4,0.8,1.1,9,1.1,9l2.4,0c0,0,0.7-5.1,0.6-6.7c0-1.8-1.4-4-1.4-4 s1.6-7.2,0.6-11.2C37.8,21.8,34.9,20.8,32,22.8z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.9,22.6c-2,0.8-0.7,12.6-1,14.6c-0.1,0.9-0.6,9.8-0.6,9.8l2.5,0.3c0,0,1.2-5.1,1.5-6.7 c0.4-1.8-0.2-3.7-0.2-3.7s3.7-6.9,3.7-11C36.8,22.9,34.1,21.3,30.9,22.6z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M38.2,23.8c0.2-2.4,0-2.9,0.1-4.5c0.1-1.6-0.2-5-0.1-6.1c0.1-1.1-0.9-4.6-3.9-4.2c-3.4,0.5-3.8,2-4.1,5 c-0.4,3-0.5,4.3-0.5,6.8c0,0.7,0.6,2.6,0.6,2.6s1.3,2,3.3,2.3C35.1,25.8,38.2,23.8,38.2,23.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.4603,
    y1: 13.7176,
    x2: 44.7774,
    y2: 13.7176
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M36.6,9.6c-1.9,0.2-1.1,3,0.4,3.9c1.2,0.7,4.4,3.3,5.6,4.4c0.3-0.8,1.4-1.1,2.2-0.8 C43,14.5,38.4,9.4,36.6,9.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159434037771074708830000010996934783503591577_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.8062,
    y1: 8.949,
    x2: 35.2352,
    y2: 8.949
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159434037771074708830000010996934783503591577_)"
    },
    d: "M32.9,10.5c0.3,0.4,1.7-0.4,2-0.7 c0.2-0.3,0.4-1.1,0.3-1.8c-0.1-0.8-1-0.7-1.5-0.5C33.1,7.6,32.5,10,32.9,10.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103254488981957305310000014529659832170958756_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.8296,
    y1: 5.5453,
    x2: 37.2444,
    y2: 5.5453
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103254488981957305310000014529659832170958756_)"
    },
    d: "M33.7,1.8c-1.3-0.1-2.9,0.8-2.9,2.5 c0,2,0.8,4.9,2.2,4.9c1.2,0,3.5-0.9,3.8-3.6c0-0.3,0.6-0.6,0.5-1.4c-0.1-0.8-0.9-0.2-0.9-0.3C36,2.8,35.2,2,33.7,1.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067945464996224218060000012658760171815505591_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.627,
    y1: 6.8551,
    x2: 32.6993,
    y2: 6.8551
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067945464996224218060000012658760171815505591_)"
    },
    d: "M32.4,5.5c-0.5,0.2-1,2.2-0.7,2.4 c0.3,0.2,0.8,0.3,0.9,0.2C32.8,8,32.5,5.5,32.4,5.5z"
  }))), /*#__PURE__*/React.createElement("g", null, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M36.5,9.4c-1.9-0.2-1.1,3.4,0,4.7c1.2,1.4,4.8,2.9,6.1,3.9c0.3-0.8,2.3-0.5,3-0.2 C44,14.6,38.7,9.6,36.5,9.4z"
  })))), /*#__PURE__*/React.createElement("g", null, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M42.4,17.4c0.1,0.3,0.2,0.5,0.2,0.6c0.1,0.4-3.5,1.9-5.1,3.3c-0.3,0.2,0.4,1.1,0.4,1.1 c-0.1,0.4,7.3-2.1,8.1-3.9c0.1-0.2-0.6-1.4-1.2-2.3C44.3,15.6,43.1,16.9,42.4,17.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114040850932116230480000011259137377263211199_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.2495,
    y1: 22.9142,
    x2: 38.2012,
    y2: 22.9142
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114040850932116230480000011259137377263211199_)"
    },
    d: "M37.8,23.7c0.4-0.2,0.4-0.7,0.3-0.9 c0-0.2-0.5-0.7-0.5-0.7l-0.4,0.5L37.8,23.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081623940817767474630000013460278533870678150_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.3118,
    y1: 22.412,
    x2: 38.5381,
    y2: 22.412
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000081623940817767474630000013460278533870678150_)"
    },
    d: "M37.5,21.3c-0.6,0.4-1.1,0.7-1.1,1.3 c-0.1,0.6,0.8,1,1.3,1.1c0.5,0.1,0.2-0.4,0.2-0.6c0-0.2-0.3-0.5,0.4-0.7C38.7,22.3,38.7,20.5,37.5,21.3z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070805736825309001200000015433358302002101949_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.6544,
    y1: 9.7088,
    x2: 26.2062,
    y2: 9.7088
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070805736825309001200000015433358302002101949_)"
    },
    d: "M23.9,11.8c-0.1-1,0-1.5-0.1-2.3 c0-0.2-0.2-1.2,0-1.2c0.1-0.1,0.3,1,0.4,0.9c0.1-0.1-0.2-1.5-0.1-1.5c0.1-0.1,0.4,1.3,0.4,1.2c0.1-0.1-0.2-1.6,0-1.6 c0.2,0,0.3,1.5,0.4,1.5c0.1,0-0.1-1.2,0.1-1.2c0.2-0.1,0.3,1.8,0.3,2c0,0.2,0.8-0.9,1-0.6c0.1,0.1-0.4,0.9-0.9,1.4 c-0.4,0.4,0,0.9,0.2,1.5c0.1,0.4-1.5,0.2-1.5,0.2L23.9,11.8z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M24,13.6c-0.1-1.8-0.4-2.6-0.1-3c0.3-0.4,1.1-0.5,1.3,0.2c0.3,1.2,1.6,5.5,1.8,6.7c0.2,1.2,0.1,2.9-0.9,3.1 C24.3,21,24.1,15.4,24,13.6z"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M38.5,46.8L38.5,46.8c0-1.6,0-3.3-0.1-4.9c0-1-0.1-2-0.4-3c-0.1-0.5-0.3-0.9-0.5-1.3 c-0.3-0.7-0.6-1.4-0.7-2.1c-0.1-0.7-0.1-1.3,0.1-1.8c0.7-3.2,1-6.5,0.6-9l0.1,0c0.4,2.5,0.2,5.8-0.6,9.1 c-0.1,0.5-0.1,1.1-0.1,1.8c0.1,0.7,0.4,1.4,0.7,2.1c0.2,0.4,0.4,0.9,0.5,1.3c0.3,1,0.4,2,0.4,3C38.5,43.5,38.5,45.1,38.5,46.8z"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.6,1.4c-1.1,0.1-3,1.6-2.4,2.7c0.6,1.1,2.6,0.5,3.3,0.2C34,4.1,35,4.7,35.6,5c0.2,0.1,0.5,0.1,0.6-0.1 c0.3-0.4,0.9-1,1-0.7c0.1,0.4-0.4-1.6-0.9-2.1C35.8,1.8,33.8,1.3,32.6,1.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step3.c0df6e80d66ebda383641f7477238ae7.svg";
export { ForwardRef as ReactComponent };